import { computed, type Ref } from 'vue'
import { ENewsStatusReverse } from '@/lib/references'
import type { NewsItemPublished } from '@/ContextTab/stores/types'


export function useNewsPublishedEntry(item: Ref<NewsItemPublished>) {

  const isRevoked = computed(() => item.value.is_revoked)
  const isUrgent = computed(() => (item.value.version?.type_id ?? 0) < 3)
  const isReleased = computed(() => item.value.version?.status_id === ENewsStatusReverse.PUBLISHED)
  const versionCodes = computed(() => item.value.version?.codes?.map(({ code }) => code) ?? [])
  const versionCodeIds = computed(() => versionCodes.value.map((code) => code.id))

  return {
    isRevoked,
    isUrgent,
    isReleased,
    versionCodes,
    versionCodeIds,
  }
}
